import components from './components';
// import search from './search';

export default {
  reqMat: {
    ...components,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/requestedMaterials/index.js